require("!!/root/anvel/node_modules/script-loader/addScript.js")(require("!!/root/anvel/node_modules/raw-loader/index.js!/root/anvel/node_modules/bootstrap/dist/js/bootstrap.min.js"))


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/script-loader!/root/anvel/~/bootstrap/dist/js/bootstrap.min.js
// module id = ../../../../script-loader/index.js!../../../../bootstrap/dist/js/bootstrap.min.js
// module chunks = 3